
















































import Modal from "../core/Modals/Modal.vue";
import { DateUtils } from "../utils/DateUtils";
import { EmployeApi } from "../api/EmployeApi";
import ConfirmSuppression from "../core/Modals/ConfirmSuppression";
import { DistanceApi } from "../api/DistanceApi";
import DistanceViewer from "./FraisDetailsModalPartials/DistanceViewer.vue";
import NumeralInput from "../core/Forms/NumeraInput.vue";
import { SettingApi } from "../api/SettingApi";
import { Setting } from "../models/Setting";
import VehiculeEdit from "./FraisDetailsModalPartials/VehiculeEdit.vue";
import NoteDeFraisEdit from "./FraisDetailsModalPartials/NoteDeFraisEdit.vue";
import { Employe } from "../models/Employe";
import { Trajet } from "../models/Trajet";
import Distance = Trajet.Distance;
import FileUploader from "../core/Forms/FileUploader.vue";

export default {
    name: "FraisDetailModal",
    components: {
        FileUploader,
        NoteDeFraisEdit,
        VehiculeEdit,
        NumeralInput,
        DistanceViewer,
        Modal,
    },
    props: {
        showModal: Boolean,
        employeId: Number,
        selectedMonth: DateUtils.Month,
    },
    data() {
        return {
            employe: null,
            vehicule: null,
            distances: [],
            EmployeApi: new EmployeApi(),
            DistanceApi: new DistanceApi(),
            SettingApi: new SettingApi(),
            noteDeFrais: new Employe.NoteDeFrais({}),
            loading: true,
        };
    },
    methods: {
        getEmploye(): Promise<Employe> {
            let self = this;
            self.employe = null;
            return self.EmployeApi.get(this.employeId).then(function (employe) {
                return (self.employe = employe);
            });
        },
        getDistances(): Promise<Distance[]> {
            let self = this;
            self.distances = [];
            return self.EmployeApi.getDistances(
                this.employeId,
                this.selectedMonth
            ).then(function (distances) {
                return (self.distances = distances);
            });
        },
        getVehicule(): Promise<Employe.Vehicule> {
            let self = this;
            return self.EmployeApi.getVehicule(this.employeId).then(function (
                vehicule
            ) {
                return (self.vehicule = vehicule);
            });
        },
        getNoteDeFrais(): Promise<Employe.NoteDeFrais> {
            let self = this;
            return self.EmployeApi.getNoteDeFrais(
                this.employeId,
                this.selectedMonth
            )
                .then(function (noteDeFrais) {
                    if (noteDeFrais) {
                        self.noteDeFrais = noteDeFrais;
                    } else {
                        self.noteDeFrais = new Employe.NoteDeFrais({
                            employe_id: self.employeId,
                            month: self.selectedMonth,
                        });
                        self.getDefaultValues();
                    }
                })
                .catch(function () {
                    self.noteDeFrais = new Employe.NoteDeFrais({});
                    self.noteDeFrais.month = self.selectedMonth;
                    self.getDefaultValues();
                });
        },
        getDefaultValues() {
            let self = this;
            return self.SettingApi.get(Setting.settingsKeys.taux_frais_km).then(
                function (res) {
                    self.noteDeFrais.taux_km = res.value;
                }
            );
        },
        updateFilesList: function (filesIds: Array<Number>): void {
            this.noteDeFrais.filesIds = filesIds;
        },
        saveAndClose() {
            let self = this;
            let promises = [];
            let noteDeFraisPromise = self.EmployeApi.saveNoteDeFrais(
                self.employeId,
                self.noteDeFrais
            ).then(function (res) {
                return res;
            });
            let vehiculePromise = self.EmployeApi.saveVehicule(
                self.employeId,
                self.vehicule
            ).then(function (res) {
                return res;
            });
            promises.push(noteDeFraisPromise);
            promises.push(vehiculePromise);
            Promise.all(promises).then(function (res) {
                self.closeModal(res);
            });
        },
        deleteNoteDeFrais() {
            let self = this;
            ConfirmSuppression.demanderRaison(
                "Voulez vous supprimer cette note de frais ?"
            ).then(function (raison) {
                if (raison === null) {
                    return;
                }
                self.EmployeApi.removeNoteDeFrais(
                    self.employeId,
                    self.selectedMonth,
                    raison
                )
                    .then(function (res) {
                        self.closeModal(res);
                    })
                    .catch(function () {
                        swal(
                            "La note de frais n'a pas pu être supprimée.",
                            "",
                            "error"
                        );
                    });
            });
        },
        closeModal(data): void {
            this.$emit("close-modal", data);
        },
    },
    watch: {
        showModal: {
            immediate: true,
            handler: function (newVal): void {
                if (newVal) {
                    let self = this;
                    self.loading = true;
                    let employePromise = self.getEmploye();
                    let noteDeFraisPromise = self.getNoteDeFrais();
                    let vehiculePromise = self.getVehicule();
                    let distancesPromise = self.getDistances();
                    let promises = [
                        employePromise,
                        noteDeFraisPromise,
                        vehiculePromise,
                        distancesPromise,
                    ];
                    Promise.all(promises).then(function () {
                        self.loading = false;
                    });
                }
            },
        },
    },
};
